import {
  OperationsInner as OperationType,
  Type as IntegrationType,
  OperationResultOutcome,
  OperationResultError,
  TokenScopesResponse,
} from '@electricjs/core_entity-client';

export type AuthorizationUrlResponse = {
  authorizationUrl: string;
};

export type IntegrationSupportResponse = {
  type?: IntegrationType;
  operations: OperationType[];
  planRestrictions: string[];
};

export const AutomationManagementStatus = {
  Automated: 'automated',
  Manual: 'manual',
  ThirdParty: 'third-party',
} as const;

export const AutomationManagementStatusDisplayText = {
  Automated: 'Automated by Electric',
  Manual: 'Manual',
  ThirdParty: 'Outside of Electric',
} as const;

export type getAppIntegrationResourceArgs = {
  organizationId: string;
  applicationKey: string;
  resourceSlug: string;
  queryParams?: Record<string, string>;
};

export type ApplicationResource = { [key: string]: unknown };

export type ApplicationResourceList = ApplicationResource[] | string[];

export type ResourceResponse = {
  result: OperationResultOutcome;
  error?: OperationResultError;
  resource?: ApplicationResourceList;
  resourceLabel: keyof ApplicationResource;
  resourceValue: keyof ApplicationResource;
  applicationId?: string;
};

export type CommonIntegrationArgs = {
  organizationId: string;
  applicationKey: string;
};

export type CreateOAuthConfigurationArgs = {
  organizationId: string;
  applicationKey: string;
  clientId: string;
  clientSecret: string;
  grantType: string;
  tokenUrl?: string;
};

export type UpdateOAuthConfigurationArgs = {
  organizationId: string;
  applicationKey: string;
  clientId?: string;
  clientSecret?: string;
  grantType?: string;
  tokenUrl?: string;
};

/**
 * OAuth scopes configured, granted, and missing for an integration.
 * Mirrors the shape of `TokenScopesResponse` from `@electricjs/core_entity-client`
 * but uses our conventional camelCase names after the transform layer.
 */
export type IntegrationTokenScopes = {
  configuredScopes: string[];
  grantedScopes: string[];
  missingScopes: string[];
};

export const toIntegrationTokenScopes = (
  response: TokenScopesResponse
): IntegrationTokenScopes => ({
  configuredScopes: response.configured_scopes,
  grantedScopes: response.granted_scopes,
  missingScopes: response.missing_scopes,
});

/**
 * A single Google Workspace product/SKU entry, as returned by the
 * `license_sku_ids` integration resource endpoint.
 */
export type GoogleProductListing = {
  composite_id: string;
  product_family: string;
  product_id: string;
  product_name: string;
  sku_id: string;
  sku_name: string;
  is_additional_license: boolean;
};
